import { render, staticRenderFns } from "./settleAccountContainer.vue?vue&type=template&id=36dd004a&scoped=true"
import script from "./settleAccountContainer.vue?vue&type=script&lang=js"
export * from "./settleAccountContainer.vue?vue&type=script&lang=js"
import style0 from "./settleAccountContainer.vue?vue&type=style&index=0&id=36dd004a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dd004a",
  null
  
)

export default component.exports